<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon modal-icon--warn">
        <mat-icon>help_outline</mat-icon>
      </div>
      <h4>Confirmation</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <p class="confirm-message">{{ message }}</p>
  </div>

  <div class="modal-footer modal-footer--custom">
    <button mat-stroked-button class="modal-action-btn" (click)="activeModal.close('cancel')">
      Cancel
    </button>
    <button mat-flat-button color="warn" class="modal-action-btn" (click)="activeModal.close('confirm')">
      <mat-icon>check</mat-icon> Confirm
    </button>
  </div>
</div>
